<template>
  <div/>
</template>

<script>
import { sleep } from '@/common/utils/sleep-util'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'MenusPublishSync',
  computed: {
    ...mapState('menuPublish', ['runningWorkflows'])
  },
  mounted () {
    this.sync()
  },
  methods: {
    ...mapActions('menuPublish', ['updateWorkflowStatus']),
    async sync () {
      while (!this._isDestroyed) {
        await sleep(2000)

        if (!this._isDestroyed) {
          const promises = []
          for (let workflow of [...this.runningWorkflows]) {
            if (workflow.syncStarted || workflow.syncDate < Date.now()) {
              promises.push(this.updateWorkflowStatus({ wfExec: workflow.wfExec, blobType: workflow.blobType }))
            }
          }

          await Promise.all(promises)
        }
      }
    }
  }
}
</script>
